import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ReplyMail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [to, setTo] = useState('');
  const [from, setFrom] = useState('');
  const [body, setBody] = useState('');
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState('');
  const [subject, setSubject] = useState('');

  // Read 'email' and 'subject' param from query string
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    setFrom(user.email || user.username || '');

    const params = new URLSearchParams(location.search);
    const emailParam = params.get('email');
    const subjectParam = params.get('subject');
    if (emailParam) {
      setTo(emailParam);
    }
    if (subjectParam) {
      setSubject(subjectParam);
    }
  }, [location]);

  const handleSend = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus('');
    try {
  const res = await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/api/send-mail`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          from,
          to,
          subject,
          message: body,
        }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setStatus('Reply sent successfully!');
        setBody('');
      } else {
        setStatus(data.message || 'Failed to send reply.');
      }
    } catch {
      setStatus('Failed to send reply.');
    }
    setSending(false);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Reply Mail</h2>
      <form onSubmit={handleSend} style={styles.form}>
        <label style={styles.label}>From:</label>
        <input
          type="text"
          value={from}
          readOnly
          style={styles.input}
        />
        <label style={styles.label}>To:</label>
        <input
          type="text"
          value={to}
          readOnly
          style={styles.input}
        />
        <label style={styles.label}>Subject:</label>
        <input
          type="text"
          value={subject}
          onChange={e => setSubject(e.target.value)}
          style={styles.input}
          required
        />
        <label style={styles.label}>Body:</label>
        <textarea
          value={body}
          onChange={e => setBody(e.target.value)}
          style={styles.textarea}
          rows={7}
          required
        />
        <button
          type="submit"
          style={styles.button}
          disabled={sending}
        >
          {sending ? 'Sending...' : 'Send'}
        </button>
        {status && <div style={styles.status}>{status}</div>}
      </form>
      <button
        style={styles.backBtn}
        onClick={() => navigate('/inbox')}
      >
        ← Back to Inbox
      </button>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  title: {
    marginBottom: '28px',
    color: '#4078c0',
    fontSize: '1.7rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  label: {
    fontWeight: 'bold',
    color: '#8d6e36',
    fontSize: '1.08rem',
    marginBottom: '6px',
  },
  input: {
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    marginBottom: '8px',
    background: '#f5f6fa',
  },
  textarea: {
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    marginBottom: '8px',
    resize: 'vertical',
  },
  button: {
    background: '#388e3c',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8e6c9',
    transition: 'background 0.2s',
    marginTop: '8px',
  },
  backBtn: {
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    textDecoration: 'none',
    marginTop: '24px',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  status: {
    textAlign: 'center',
    color: '#388e3c',
    fontWeight: 'bold',
    marginTop: '8px',
  },
};

export default ReplyMail;